/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { initTheme } from "@/components";
import { initCart } from "@/components/cart";

const init = () => {
    initTheme();
    initCart();
};

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
